export default __webpack_public_path__ + "static/media/sypialnie3.1c83b147.jpg";